import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { AuthProviderWeb } from "react-redux-django-auth/web";
import { HelmetProvider } from "react-helmet-async";
import { CartProvider } from "./hooks/useCart";
import { ToastProvider } from "./hooks/otherHooks/useToast";
import { RouterProvider } from "react-router-dom";
import { router } from "./routers/router";
import CodeCopyEnhancer from "./utils/codeCopyFun";
import { AppStateBridge } from "./context/LegacyContextBridge";

// Re-export all 16 legacy contexts for 100% backward compatibility with downstream imports
export {
  ServiceContext,
  CompanyInfoContext,
  JobContext,
  CategoryContext,
  ClientContext,
  CoreValuesContext,
  TechContext,
  IndustryContext,
  WorkProcessContext,
  TeamContext,
  TestimonialContext,
  JobOpeningContext,
  CourseTrackContext,
  CourseContext,
  CourseHeroContext,
  BlogContext,
} from "./context/LegacyContextBridge";

function App() {
  return (
    <AuthProviderWeb
      apiUrl={process.env.REACT_APP_API_URL || ""}
      authTokenType="JWT"
    >
      <HelmetProvider>
        <ToastProvider>
          <CartProvider>
            <AppStateBridge>
              <CodeCopyEnhancer />
              <RouterProvider router={router} />
            </AppStateBridge>
          </CartProvider>
        </ToastProvider>
      </HelmetProvider>
    </AuthProviderWeb>
  );
}

export default App;
